import currencyFormat from "currency.js";

export const percentFormat = (valor) => {
  return currencyFormat(valor, {
    symbol: "% ",
    separator: ".",
    formatWithSymbol: true,
  }).format();
};
